<fm-context-menu
  [position]="menuData.clickPosition"
  [isRightClickDisabled]="true"
  class="map-menu-container"
  a7s-id="live-map-context-menu"
  (closed)="onMenuClosed()"
  (copyCoordinatesClicked)="onCopyCoordinates($event)"
  menuName="Map"
  [latLng]="menuData.clickLatLng"
  i18n-menuName="@@S_MAP"
>
  <fm-context-menu-panel>
    <fm-context-menu-item
      *ngIf="userPermissions.findNearest"
      id="lnk-map-find-nearest"
      [hasSeparator]="showFindNearestSeparator"
      (click)="onFindNearestClicked()"
    >
      <a i18n="@@S_FIND_NEAREST">Find Nearest</a>
    </fm-context-menu-item>
    <fm-context-menu-item *ngIf="userPermissions.zoomTo" id="lnk-map-zoom-to" (click)="onZoomToClicked()">
      <a i18n="@@S_ZOOM_TO">Zoom to</a>
    </fm-context-menu-item>
    <fm-context-menu-item
      *ngIf="userPermissions.streetView"
      id="lnk-map-street-view"
      (click)="onStreetViewClicked()"
      [isDisabled]="!menuData.streetViewAvailable"
    >
      <a i18n="@@S_STREET_VIEW">Street View</a>
    </fm-context-menu-item>
    <fm-context-menu-item
      *ngIf="userPermissions.createGeofence"
      id="lnk-map-create-geofence-here"
      [hasSeparator]="showCreateGeofenceSeparator"
      (click)="onCreateGeofenceClicked()"
    >
      <a i18n="@@S_CREATE_A_GEOFENCE_HERE">Create a Geofence here</a>
    </fm-context-menu-item>
    <fm-context-menu-item
      *ngIf="userPermissions.managePostedSpeed"
      id="lnk-map-manage-posted-speed"
      a7s-id="EntrySource_Live Map"
      [hasSeparator]="showManagePostedSpeedSeparator"
      (click)="onManagePostedSpeedClicked()"
    >
      <a i18n="@@S_MANAGE_POSTED_SPEED">Manage posted speed</a>
    </fm-context-menu-item>
    <fm-context-menu-item *ngIf="userPermissions.sendToGarmin" id="lnk-map-send-location-to-garmin" (click)="onLocationToGarminClicked()">
      <a i18n="@@S_SEND_LOCATION_TO_GARMIN">Send location to a Garmin</a>
    </fm-context-menu-item>
    <fm-context-menu-item
      *ngIf="userPermissions.driverDispatch"
      [hasSeparator]="showDriverDispatchSeparator"
      id="lnk-map-open-driver-dispatch"
      (click)="onDriverDispatchClicked()"
    >
      <a i18n="@@S_OPEN_DRIVER_DISPATCH">Open Driver Dispatch</a>
    </fm-context-menu-item>
    <fm-context-menu-item *ngIf="userPermissions.directions" id="lnk-map-get-directions-to-here" (click)="onGetDirectionToClicked()">
      <a i18n="@@S_GET_DIRECTIONS_TO_HERE">Get Directions to here</a>
    </fm-context-menu-item>
    <fm-context-menu-item *ngIf="userPermissions.directions" id="lnk-map-get-direction-from-here" (click)="onGetDirectionFromClicked()">
      <a i18n="@@S_GET_DIRECTIONS_FROM_HERE">Get Directions from here</a>
    </fm-context-menu-item>
  </fm-context-menu-panel>
</fm-context-menu>
